module.exports = __webpack_public_path__ + "img/prices.cfaeddc2.png";